import { isEqual, reduce } from '../../../util/lodashlike';

export const getInitialValues = (arrayCollection = []) =>
  reduce(
    arrayCollection,
    (result, item) => {
      result[item.confKey] = item.value;
      return result;
    },
    {}
  );

export const getDiffValues = (collectionLeft = {}, collectionRight = {}) =>
  reduce(
    collectionLeft,
    (result, value, key) => {
      if (!isEqual(value, collectionRight[key])) {
        result.push({ key, value });
      }
      return result;
    },
    []
  );
